import useMediaQuery from '@material-ui/core/useMediaQuery';

const useHoverSupported = () =>
  !useMediaQuery('(hover: none)', {
    noSsr: true
  });

export default useHoverSupported;
